export default __webpack_public_path__ + "static/video-d7b4f2bf7ade7ec08a76529d524f147a.mp4";